import React from "react"

import {hasProperty, formatText} from '../utils/utils';

import dsd from '../classes/clsDSD';

import * as PD from '../classes/pdStyle';


class ViewInterface extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,
            noLinks: false,
        };


        this.dsd = new dsd();
        this.dsd.StateObject = this;

        this.data = {};
        this.data.Interface = null;

        if (this.props.Interface){
            this.data.Interface = this.props.Interface; 
        }

        if (this.props.noLinks){
            this.state.noLinks = this.props.noLinks; 
        }


        this.filters = {};

        this.columns = {
        };

        this.data.id = null;
        if (this.props.id){
            this.data.id = this.props.id; 
        }


    }

    componentDidMount() {

        if (this.data.Interface){
            this.setState({"isLoaded":true});
            return;
        }

    };

    view(json){

        if (json){
            return(
                <PD.Table className="panel">
                    <PD.Tbody>                                

                        {hasProperty(json,'name') &&
                            <PD.Tr>
                                <PD.Th>Name</PD.Th>
                                <PD.Td>
                                    {(() => {
                                        switch (this.state.noLinks) {
                                            case true:
                                                return json.name
                                            default:
                                                return (
                                                    <PD.PdNavLink to={"/interface/" + json._id} >
                                                        {json.name}
                                                    </PD.PdNavLink>
                                                )
                                        }
                                    })()}
                                </PD.Td>
                            </PD.Tr>
                        }

                        {hasProperty(json,'description') &&
                            <PD.Tr>
                                <PD.Th>Description</PD.Th><PD.Td>
                                    <PD.MdPresent>
                                        {json.description}
                                    </PD.MdPresent>
                                </PD.Td>
                            </PD.Tr>
                        }

                        {hasProperty(json,'proposals') &&
                            <PD.Tr>
                                <PD.Th>Proposals</PD.Th><PD.Td>
                                    <PD.MdPresent>{json.proposals}</PD.MdPresent>
                                </PD.Td>
                            </PD.Tr>
                        }

                        {json.DataSpecs && json.DataSpecs.length>0 && 
                            <PD.Tr>
                                <PD.Th>Data Specs</PD.Th>
                                <PD.Td>
                                    <ul>
                                        {json.DataSpecs.map(
                                            (InterfaceDataSpec, pos) => 
                                            {
                                                if (InterfaceDataSpec.DataSpec){
                                                    return (
                                                        <li key={pos}>
                                                            {(() => {
                                                                switch (this.state.noLinks) {
                                                                    case true:
                                                                        return InterfaceDataSpec.DataSpec.name
                                                                    default:
                                                                        return (
                                                                            <PD.PdNavLink to={"/dataspec/" + InterfaceDataSpec.DataSpec._id} >
                                                                                {InterfaceDataSpec.DataSpec.name}
                                                                            </PD.PdNavLink>
                                                                        )
                                                                }
                                                            })()}
                                                        </li>
                                                    )
                                                }
                                                return null;
                                            })
                                        }
                                    </ul>
                                </PD.Td>
                            </PD.Tr>
                        }


                        {hasProperty(json,'status') &&
                            <PD.Tr>                                
                                <PD.Th>Status</PD.Th><PD.Td>{json.status}</PD.Td>
                            </PD.Tr>
                        }

                        {json.Owner &&
                            <PD.Tr>
                                <PD.Th>Owner</PD.Th><PD.Td>{json.Owner.organisation}</PD.Td>
                            </PD.Tr>
                        }

                    </PD.Tbody>
                </PD.Table>
            )
        };
        return null;
    };

    render() {

        if (this.state.isLoaded) {

            return (
                <div>
                    {this.view(this.data.Interface)}
                </div>
            )
        }
        else {
            return <div />;
        }

    };    
};
        
export default ViewInterface;